import React, { FC } from 'react';
import styled from 'styled-components';

export const GridContainer = styled.div<{ itemsAmount: number }>`
    padding: 20px;
    display: grid;
    grid-template-columns: ${({ itemsAmount }) => `repeat(${itemsAmount}, 1fr)`};
    gap: 16px;
    width: 100%;

    @media (max-width: 1260px) {
        grid-template-columns: repeat(2, 1fr);
    }

    @media (max-width: 768px) {
        grid-template-columns: 1fr;
    }
`;

export const CardBox = styled.div<{ highlight?: boolean; showStar?: boolean }>`
    padding: 20px 10px;
    background: ${({ highlight }) => highlight ? 'var(--color-alt-light)' : 'var(--color-alt-second)'};
    border-radius: var(--box-border-radius);
    border: 1px solid var(--color-alt-second-10);
    position: relative;
    overflow: hidden;
    display: flex;
    flex-direction: column;
    align-items: center;

    &::after {
        content: ${({ showStar }) => showStar ? '\'★\'' : '\'\''};
        position: absolute;
        top: 16px;
        right: 12px;
        font-size: 14px;
        opacity: 0.7;
        color: var(--color-alt);
    }
`;

export const CardLabel = styled.div<{ isSmall?: boolean }>`
    font-size: ${({ isSmall }) => isSmall ? '12px' : '16px'};
    opacity: 0.9;
    margin-bottom: 8px;
    line-height: 1.3;
    display: flex;
    gap: 10px;
    justify-content: space-between;
    padding-right: 10px;
    align-items: center;

    img {
        height: 18px;
    }
`;

export const CardValue = styled.div`
    font-size: 18px;
    font-weight: 600;
    min-width: 150px;
    text-align: center;
`;

export const HelperText = styled.div`
    font-size: 11px;
    color: rgba(150, 70, 70, 0.9);
    margin-top: 8px;
    text-align: center;
`;

export interface CardItem {
    label: string;
    value?: string | number | null;
    suffix?: string;
    content?: React.ReactNode;
    highlight?: boolean;
    showStar?: boolean;
    helperText?: string;
}

interface CardsGridProps {
    items: CardItem[];
    isSmallLabel?: boolean;
}

const CardsGrid: FC<CardsGridProps> = ({ items, isSmallLabel }) => {
    return (
        <GridContainer itemsAmount={items.length}>
            {items.map((item, index) => <CardBox key={index} highlight={item.highlight} showStar={item.showStar}>
                <CardLabel isSmall={isSmallLabel}>{item.label}</CardLabel>
                {item.content
                    ? item.content
                    : <CardValue>
                        {item.value} {item.value && item.suffix}
                    </CardValue>
                }
                {item.helperText && <HelperText>{item.helperText}</HelperText>}
            </CardBox>)}
        </GridContainer>
    );
};

export default CardsGrid;
